import useAgencyProviderPriceOverride,
{ useAgencyProviderPriceOverrideForm } from '@hooks/useAgencyProviderPriceOverride'

import {
  AgencyProviderPriceOverrideModel, ProviderPriceListItemModel, ProviderPriceListModel, ServiceProductModel,
} from '@models/types'
import defaultRequestOptions from '@sections/Admin/packs/SystemManager/defaultRequestOptions'

type MapStateToPriceOverrideParams = {
  entityState?: Partial<AgencyProviderPriceOverrideModel>,
  state?: {
    selectedItem?: Partial<ProviderPriceListItemModel>,
    selectedOptions?: Array<object>,
    selectedPriceList?: Partial<ProviderPriceListModel>,
    selectedProduct?: Partial<ServiceProductModel>,
  },
}

const mapStateToPriceOverride = (params: MapStateToPriceOverrideParams) => {
  const { entityState, state } = params
  const {
    selectedItem,
    selectedOptions,
    selectedPriceList,
    selectedProduct,
  } = state || {}

  const priceOverride = {
    ...entityState,
    options: selectedOptions,
    provider_price_list_id: selectedPriceList?.id,
    provider_price_list_item_id: selectedItem?.id,
    service_id: selectedProduct?.service_id,
    service_product_id: selectedProduct?.id,
  }

  return priceOverride
}

type Params = {
  agencyProviderPriceOverride?: AgencyProviderPriceOverrideModel,
  state?: {
    selectedItem?: Partial<ProviderPriceListItemModel>,
    selectedOptions?: Array<object>,
    selectedPriceList: Partial<ProviderPriceListModel>,
    selectedProduct: Partial<ServiceProductModel>,
  },
}

const useCreateOrEditAgencyProviderPriceOverrideModal = (params: Params = {}) => {
  const {
    agencyProviderPriceOverride,
    state,
  } = params

  const { provider_id } = agencyProviderPriceOverride || {}

  const {
    selectedItem,
    selectedPriceList,
    selectedProduct,
  } = state || {}

  const {
    callbacks: {
      createAgencyProviderPriceOverride,
      deleteAgencyProviderPriceOverride,
      updateAgencyProviderPriceOverride,
    },
    creating,
    deleting,
    updating,
  } = useAgencyProviderPriceOverride(
    agencyProviderPriceOverride,
    {
      requestOptions: defaultRequestOptions.agencyProviderPriceOverride,
      performHttpRequests: !!agencyProviderPriceOverride?.id,
    },
  )

  const agencyProviderPriceOverrideFormPayload = useAgencyProviderPriceOverrideForm(
    // @ts-expect-error TS2345
    agencyProviderPriceOverride,
    { validateOn: 'change' },
  )
  const {
    entityState,
    errors,
    handlers,
    setEntityState,
  } = agencyProviderPriceOverrideFormPayload

  const saveEnabled = agencyProviderPriceOverride?.id
    ? true
    : !!(
      selectedPriceList?.id
    && selectedProduct?.id
    && selectedItem?.id
    )

  return {
    callbacks: {
      createAgencyProviderPriceOverride,
      deleteAgencyProviderPriceOverride,
      mapStateToPriceOverride: () => mapStateToPriceOverride({ entityState, state }),
      updateAgencyProviderPriceOverride,
    },
    creating,
    deleting,
    entityState,
    errors,
    handlers,
    providerId: provider_id,
    saveEnabled,
    setEntityState,
    updating,
  }
}

export default useCreateOrEditAgencyProviderPriceOverrideModal
